const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    duplicateWarning: () =>
        __('Du har allerede en Jobagent med de samme søgeparametre:'),
    email: () =>
        __('E-mail'),
    keywords: () =>
        __('Søgeord'),
    categories: () =>
        __('Kategorier'),
    oldCategories: () =>
        __('Gamle kategorier'),
    oldCategoryTooltip: () =>
        __('Gem din Jobagent for at fjerne denne notifikation'),
    geoDistance: () =>
        __('Geografisk afstand'),
    areas: () =>
        __('Områder'),
    addAreas: () =>
        __('Tilføj områder'),
    companies: () =>
        __('Virksomheder'),
    companiesHelpText: () =>
        __('Du kan begrænse din Jobagent til udvalgte virksomheder, hvis du ønsker at holde særligt øje med dem.'),
    name: () =>
        __('Navngiv Jobagent'),
    nameHelpText: () =>
        __('Hvis du har flere Jobagenter kan du navngive dem for nemmere at kunne kende forskel på den.'),
    enableLabel: () =>
        __('Få opdateringer på e-mail'),
    daily: () =>
        __('Hver dag'),
    weekly: () =>
        __('Hver lørdag'),
    cancel: () =>
        __('Annuller'),
    save: () =>
        __('Gem'),
    saving: () =>
        __('Gemmer…'),
    settings: () =>
        __('Indstillinger'),
    emailInstruction: (email, settingsLabel) =>
        __x('Din Jobagent vil blive sendt til {email}. Du kan rette din e-mailadresse under "{settings_label}".', { email, settings_label: settingsLabel }),
    preferredTransportation: () =>
        __('Foretrukket transportmiddel'),
    automatic: () =>
        __('Automatisk'),
    bike: () =>
        __('Cykel'),
    car: () =>
        __('Bil'),
    transit: () =>
        __('Offentlige transportmidler'),
    traveltimeExplanationHeadline: () =>
        __('Se rejsetid på annoncerne i din Jobagent!'),
    traveltimeExplanationIntro: () =>
        __('For at se din rejsetid, skal du gøre mindst én af to ting:'),
    traveltimeExplanation1: () =>
        __('Brug radius nedenfor'),
    traveltimeExplanation2: () =>
        __('Indtast adresse i din <link:brugerinformation>'),
    traveltimeExplanationTip: () =>
        __('<strong:TIP:> Vælg dit favorit transportmiddel nederst på denne side.'),
};
